var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { when } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React from 'react';
import { ContextColor } from '../../constants/color.enum';
import { useOnMount } from '../../hooks/lifecycle.hooks';
import { useObservableRef } from '../../hooks/useObservableRef.hook';
import { useResizeQuery } from '../../hooks/useResizeQuery';
import joinClassName from '../../utils/className.utils';
import { getContextColorStyle } from '../../utils/colors.utils';
import { debounce } from '../../utils/debouncer.utils';
import { useProps } from '../../utils/mobx.utils';
import { convertKeyValuePairArrayToObject } from '../../utils/objects.utils';
import tick, { doEvery } from '../../utils/waiters.utils';
import TitleBarHeightSpacer from '../TitleBarHeightSpacer/TitleBarHeightSpacer';
import './AppPage.scss';
var AppPage = function (props) {
    var _a;
    var p = useProps(props);
    var innerRef = useObservableRef();
    var ref = (_a = props.pageContainerRef) !== null && _a !== void 0 ? _a : innerRef;
    var query = useResizeQuery(ref);
    // const { NAVIGATOR } = useControllers();
    var resizeHandler = debounce(function () {
        when(function () { return Boolean(ref.current); }, function () { return __awaiter(void 0, void 0, void 0, function () {
            var width, height;
            var _a, _b, _c, _d, _e, _f;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (query.width === 0 || query.height === 0)
                            return [2 /*return*/];
                        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.style.removeProperty('width');
                        (_b = ref.current) === null || _b === void 0 ? void 0 : _b.style.removeProperty('height');
                        return [4 /*yield*/, tick(100)];
                    case 1:
                        _g.sent();
                        width = query.width, height = query.height;
                        (_c = ref.current) === null || _c === void 0 ? void 0 : _c.style.setProperty('width', width + 'px');
                        (_d = ref.current) === null || _d === void 0 ? void 0 : _d.style.setProperty('height', height + 'px');
                        (_e = ref.current) === null || _e === void 0 ? void 0 : _e.style.setProperty('--AppPageWidth', width + 'px');
                        (_f = ref.current) === null || _f === void 0 ? void 0 : _f.style.setProperty('--AppPageHeight', height + 'px');
                        return [2 /*return*/];
                }
            });
        }); });
    });
    useOnMount(function () {
        var disposers = [];
        if (!p.shouldDetectOwnDimensions)
            return;
        window.addEventListener('resize', resizeHandler);
        resizeHandler();
        query.onResize(resizeHandler);
        disposers.push(function () {
            window.removeEventListener('resize', resizeHandler);
        });
        if (p.shouldDetectOwnDimensions) {
            disposers.push(doEvery(resizeHandler, 5000));
        }
        // disposers.push(NAVIGATOR.onPathnameChange(resizeHandler));
        return function () { return disposers.forEach(function (d) { return d(); }); };
    });
    return React.createElement(Observer, { children: function () {
            var style = __assign({}, getContextColorStyle(ContextColor.Primary, p.color));
            var dataAttributes = convertKeyValuePairArrayToObject(Object.entries(p).filter(function (p) { return p[0].match('data-'); }));
            return (React.createElement("div", __assign({ 
                // {...props}
                className: joinClassName('AppPage', p.className, p.fixedHeight && 'fixedHeight', p.accommodateTitleBarSpace && 'accommodateTitlebarSpace'), ref: ref, style: style, "data-display-mode": query === null || query === void 0 ? void 0 : query.displayMode, "data-only-phones": query === null || query === void 0 ? void 0 : query.onlyPhones, "data-from-tablet": query === null || query === void 0 ? void 0 : query.fromTablet, "data-from-desktop": query === null || query === void 0 ? void 0 : query.fromDesktop }, dataAttributes),
                p.accommodateTitleBarSpace && React.createElement(TitleBarHeightSpacer, null),
                props.children));
        } });
};
export default AppPage;
